import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { columnWidthSetAction } from '../../../../../asidePanel/store/actions/columnWidthSetAction';
import { vent } from '../../../../../../../../store/constants';

export const onColumnWidthChange = (
    columnWidth: number,
): ThunkAction => {
    return (dispatch: Dispatch) => {
        dispatch(columnWidthSetAction(columnWidth));
    };
};
